export default __webpack_public_path__ + "static/media/funeral.aeb29c89.mp4";